import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTooltipOnEllipsis]',
  standalone: true,
})
export class TooltipOnEllipsisDirective {
  private tooltip: HTMLElement | null = null;
  private isOverPopup = false;
  private isOverText = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter() {
    this.isOverText = true;
    const element = this.elementRef.nativeElement;
    if (element.offsetWidth < element.scrollWidth) {
      this.tooltip = element.parentElement.querySelector('.tooltip-popup');
      if (this.tooltip) {
        this.renderer.addClass(this.tooltip, 'show');
        // Add listeners to the popup
        this.tooltip.addEventListener('mouseenter', this.onPopupEnter);
        this.tooltip.addEventListener('mouseleave', this.onPopupLeave);
      }
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.isOverText = false;
    setTimeout(() => {
      if (!this.isOverPopup) {
        this.hideTooltip();
      }
    }, 50);
  }

  onPopupEnter = () => {
    this.isOverPopup = true;
  };

  onPopupLeave = () => {
    this.isOverPopup = false;
    setTimeout(() => {
      if (!this.isOverText) {
        this.hideTooltip();
      }
    }, 50);
  };

  private hideTooltip() {
    if (this.tooltip) {
      this.renderer.removeClass(this.tooltip, 'show');
      this.tooltip.removeEventListener('mouseenter', this.onPopupEnter);
      this.tooltip.removeEventListener('mouseleave', this.onPopupLeave);
      this.tooltip = null;
    }
  }
} 